import { render } from "./ClinicalResearchDetail.vue?vue&type=template&id=0f27c224"
import script from "./ClinicalResearchDetail.vue?vue&type=script&lang=js"
export * from "./ClinicalResearchDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__